import { render, staticRenderFns } from "./print-footer.vue?vue&type=template&id=4c504182&scoped=true"
import script from "./print-footer.vue?vue&type=script&lang=js"
export * from "./print-footer.vue?vue&type=script&lang=js"
import style0 from "./print-footer.vue?vue&type=style&index=0&id=4c504182&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c504182",
  null
  
)

export default component.exports